export default function CryptoSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-8 md:p-12 relative overflow-hidden">
          {/* Background accent */}
          <div className="absolute top-0 right-0 w-72 h-72 bg-green-500/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-teal-500/10 rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <span className="inline-flex items-center gap-1.5 bg-yellow-400/20 border border-yellow-400/30 text-yellow-300 text-xs font-bold px-3 py-1.5 rounded-full mb-5">
                <i className="ri-coin-line" />
                Alternativa Digital
              </span>
              <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-4 leading-tight">
                Enviar dinero con
                <br />
                <span className="text-yellow-400">criptomonedas (USDT)</span>
              </h2>
              <p className="text-slate-400 text-sm leading-relaxed mb-6">
                Las criptomonedas como el USDT (Tether) son una alternativa creciente para enviar dinero a Venezuela. Muy utilizadas en el país por su estabilidad frente al dólar.
              </p>
              <ul className="flex flex-col gap-3 mb-8">
                {[
                  { icon: 'ri-flashlight-line', text: 'Puede ser más rápido que servicios tradicionales', color: 'text-yellow-400' },
                  { icon: 'ri-global-line', text: 'Sin fronteras ni restricciones bancarias', color: 'text-green-400' },
                  { icon: 'ri-shield-check-line', text: 'Muy utilizado y aceptado en Venezuela', color: 'text-teal-400' },
                  { icon: 'ri-money-dollar-circle-line', text: 'Estable al dólar (stablecoin)', color: 'text-blue-400' },
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-slate-300">
                    <span className={`w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5 ${item.color}`}>
                      <i className={item.icon} />
                    </span>
                    {item.text}
                  </li>
                ))}
              </ul>
              <button
                className="inline-flex items-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-slate-900 font-bold text-sm px-6 py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap hover:scale-105"
              >
                <i className="ri-coin-line" />
                Más información próximamente
              </button>
              <p className="text-slate-500 text-xs mt-3">
                Estamos preparando una guía completa sobre cómo enviar USDT a Venezuela.
              </p>
            </div>

            <div className="flex flex-col gap-4">
              <div className="bg-slate-700/60 border border-slate-600 rounded-2xl p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-yellow-400/20 rounded-xl">
                    <i className="ri-coin-line text-yellow-400 text-xl" />
                  </div>
                  <div>
                    <div className="text-white font-bold text-sm">USDT (Tether)</div>
                    <div className="text-slate-400 text-xs">Stablecoin más usada en Venezuela</div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { label: 'Paridad', value: '1 USDT = $1 USD' },
                    { label: 'Velocidad', value: 'Minutos' },
                    { label: 'Comisión', value: 'Variable' },
                    { label: 'Red', value: 'TRC-20 / BEP-20' },
                  ].map((item, i) => (
                    <div key={i} className="bg-slate-800/60 rounded-xl p-3">
                      <div className="text-slate-500 text-xs mb-0.5">{item.label}</div>
                      <div className="text-white text-xs font-bold">{item.value}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-yellow-400/10 border border-yellow-400/20 rounded-2xl p-5">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-yellow-400 flex-shrink-0 mt-0.5" />
                  <p className="text-slate-300 text-xs leading-relaxed">
                    <strong className="text-yellow-300">Nota importante:</strong> El uso de criptomonedas conlleva riesgos. Asegúrate de entender cómo funcionan antes de usarlas. Esta guía es solo informativa.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
